<template>
  <main class="main profile-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item">Profile</router-link>
            <router-link to="/orders" class="item">Orders</router-link>
            <router-link v-if="this.$parent.offerEnabled" to="/offers" class="item">Offers</router-link>
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-table">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title small">Orders</div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ formatToEST(item.created_at) }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.sum }} {{ currencySymbol }}</td>
                      <td>{{ item.status }}</td>
                      <td>
                        <a class="offer-modal-open" @click="$emit('openOfferDetailsModal', item)">View</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "Orders",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  methods: {
    formatToEST(timestamp) {
      if (!timestamp) return "";
      const momentObj =
        typeof timestamp === "number"
          ? moment.unix(timestamp)
          : moment(timestamp, "DD.MM.YYYY HH:mm");

      return momentObj.tz("Europe/Tallinn").format("DD.MM.YYYY HH:mm");
    },
  },
  computed: {
    ...mapGetters("app", ["currencySymbol"]),
  },
};
</script>